import { render, staticRenderFns } from "./ImageAnnotationCanvas.vue?vue&type=template&id=0a081464&scoped=true&"
import script from "./ImageAnnotationCanvas.vue?vue&type=script&lang=ts&"
export * from "./ImageAnnotationCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./ImageAnnotationCanvas.vue?vue&type=style&index=0&id=0a081464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a081464",
  null
  
)

export default component.exports